import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Register() {
  const { t, register } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", phone: "", email: "", password: "", role: "owner" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center p-6">
      <Card className="w-full max-w-md p-8 rounded-2xl">
        <h1 className="font-heading text-3xl font-bold mb-6">{t("register")}</h1>
        <form onSubmit={submit} className="space-y-4">
          <Input placeholder={t("name")} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="reg-name" className="h-14 rounded-lg" />
          <Input placeholder={t("phone")} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="reg-phone" className="h-14 rounded-lg" />
          <Input placeholder={t("email")} type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" className="h-14 rounded-lg" />
          <Input placeholder={t("password")} type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="reg-password" className="h-14 rounded-lg" />
          <div className="flex gap-2">
            <button type="button" onClick={() => setForm({ ...form, role: "owner" })} data-testid="reg-role-owner"
                    className={`flex-1 h-12 rounded-xl text-sm font-medium ${form.role === "owner" ? "bg-[#B45309] text-white" : "bg-stone-100 text-stone-700"}`}>{t("owner")}</button>
            <button type="button" onClick={() => setForm({ ...form, role: "staff" })} data-testid="reg-role-staff"
                    className={`flex-1 h-12 rounded-xl text-sm font-medium ${form.role === "staff" ? "bg-[#B45309] text-white" : "bg-stone-100 text-stone-700"}`}>{t("staff")}</button>
          </div>
          <Button disabled={busy} data-testid="reg-submit" className="w-full h-14 rounded-xl bg-[#B45309] hover:bg-[#92400E] text-white font-semibold text-lg">
            {t("register")}
          </Button>
        </form>
        <div className="mt-4 text-sm text-stone-500 text-center">
          <Link to="/login" className="text-[#B45309] font-medium">{t("login")}</Link>
        </div>
      </Card>
    </div>
  );
}
